import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import { LanguageProvider } from './contexts/LanguageContext';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

// Load each page only when its route is opened, keeping the first visit light.
const Home = lazy(() => import('./pages/Home'));
const About = lazy(() => import('./pages/About'));
const MeetOurTeam = lazy(() => import('./pages/MeetOurTeam'));
const Services = lazy(() => import('./pages/Services'));
const ModulePage = lazy(() => import('./pages/ModulePage'));
const Methodology = lazy(() => import('./pages/Methodology'));
const Insights = lazy(() => import('./pages/Insights'));
const Contact = lazy(() => import('./pages/Contact'));
const StewardshipSeries = lazy(() => import('./pages/StewardshipSeries'));
const GlobalInvestmentHorizon = lazy(() => import('./pages/GlobalInvestmentHorizon'));
const GlobalCitizen = lazy(() => import('./pages/GlobalCitizen'));
const FoundersForum = lazy(() => import('./pages/FoundersForum'));
const ArticleDetail = lazy(() => import('./pages/ArticleDetail'));

function App() {
  return (
    <LanguageProvider>
      <Router>
        <div className="App">
          <Navigation />
          <Suspense fallback={<div className="route-loading" role="status">Loading…</div>}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/meet-our-team" element={<MeetOurTeam />} />
              <Route path="/your-experience" element={<Navigate to="/about#how-we-work" replace />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/:moduleId" element={<ModulePage />} />
              {/* 旧地址跳转到对应的新模块页，避免外部链接失效 */}
              <Route path="/family-office-advisory" element={<Navigate to="/services/family-governance" replace />} />
              <Route path="/investment-advisory" element={<Navigate to="/services/investment-execution" replace />} />
              <Route path="/wealth-planning" element={<Navigate to="/services/asset-structuring" replace />} />
              <Route path="/service/*" element={<Navigate to="/services" replace />} />
              <Route path="/methodology" element={<Methodology />} />
              <Route path="/insights" element={<Insights />} />
              <Route path="/insights/stewardship" element={<StewardshipSeries />} />
              <Route path="/insights/investment" element={<GlobalInvestmentHorizon />} />
              <Route path="/insights/global-citizen" element={<GlobalCitizen />} />
              <Route path="/insights/founders-forum" element={<FoundersForum />} />
              <Route path="/article/:articleId" element={<ArticleDetail />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </Suspense>
          <Footer />
          <ScrollToTop />
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;
